import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';


// Initial state
const initialState = {
  status: 'idle',
  user: null,
  token:null,
  error: null,
  isLoading: false,
  message: null,
};

// Slice
const infoSlice = createSlice({
  name: 'info',
  initialState,
  reducers: {
    info: (state,action) => { 
      state.status = 'idle';
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
  },

});

// Export actions and reducer
export const { info } = infoSlice.actions;
export default infoSlice.reducer;
